/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type NOTIFICATION_TYPE = "COMMENT_APPROVED" | "COMMENT_FEATURED" | "COMMENT_REJECTED" | "DSA_REPORT_DECISION_MADE" | "ILLEGAL_REJECTED" | "PREVIOUSLY_REJECTED_COMMENT_APPROVED" | "REPLY" | "REPLY_STAFF" | "UNKNOWN" | "%future added value";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MEMBER" | "MODERATOR" | "QUESTION" | "REVIEW" | "STAFF" | "UNANSWERED" | "%future added value";
export type NotificationContainer_notification = {
    readonly type: NOTIFICATION_TYPE | null;
    readonly id: string;
    readonly createdAt: string;
    readonly commentStatus: COMMENT_STATUS | null;
    readonly comment: {
        readonly id: string;
        readonly story: {
            readonly url: string;
        };
        readonly " $fragmentRefs": FragmentRefs<"NotificationCommentContainer_comment">;
    } | null;
    readonly commentReply: {
        readonly tags: ReadonlyArray<{
            readonly code: TAG;
        }>;
        readonly id: string;
        readonly author: {
            readonly username: string | null;
            readonly badges: ReadonlyArray<string> | null;
        } | null;
        readonly story: {
            readonly url: string;
        };
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"RejectedCommentNotificationBody_notification" | "DSAReportDecisionMadeNotificationBody_notification" | "CommentNotificationBody_notification">;
    readonly " $refType": "NotificationContainer_notification";
};
export type NotificationContainer_notification$data = NotificationContainer_notification;
export type NotificationContainer_notification$key = {
    readonly " $data"?: NotificationContainer_notification$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationContainer_notification">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "alias": null,
        "args": null,
        "concreteType": "Story",
        "kind": "LinkedField",
        "name": "story",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "NotificationContainer_notification",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commentStatus",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "comment",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "NotificationCommentContainer_comment"
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "commentReply",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "code",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "username",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "badges",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    (v1 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RejectedCommentNotificationBody_notification"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DSAReportDecisionMadeNotificationBody_notification"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CommentNotificationBody_notification"
            }
        ],
        "type": "Notification",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '57ed863d411e2f3aaf9d4b28130350d0';
export default node;
